import { api } from './client';

// 사용 가능한 객실 정보
export interface RoomWithInfo {
  roomId: string;
  roomAddress: string;
  roomType: string;
  password: string | null;
  todayCheckoutTime: string | null;
  todayLateCheckout: boolean;
  todayLateCheckoutTime: string | null;
  todayCheckinTime: string | null;
  isStaying: boolean;
  lastPasswordChange: string | null;
  daysSinceChange: number | null;
  isAlreadySelected: boolean;
}

// 비밀번호 변경 대상 정보
export interface PasswordChange {
  id: number;
  roomId: string;
  roomAddress: string;
  selectedDate: string;
  currentPassword: string | null;
  newPassword: string | null;
  status: 'pending' | 'reserved' | 'applied' | 'cancelled';
  reservedAt: string | null;
  appliedAt: string | null;
  todayCheckoutTime: string | null;
  todayLateCheckout: boolean;
  todayLateCheckoutTime: string | null;
  todayCheckinTime: string | null;
  isStaying: boolean;
  lastPasswordChange: string | null;
  daysSinceChange: number | null;
}

export const passwordsApi = {
  // 사용 가능한 객실 목록 조회
  getAvailableRooms: async (date: string) => {
    const response = await api.get(`/passwords/rooms/${date}`);
    return response.data.data as RoomWithInfo[];
  },

  // 선택된 객실 목록 조회 (pending/reserved)
  getPendingChanges: async (date: string) => {
    const response = await api.get('/passwords', { params: { date } });
    return response.data.data as PasswordChange[];
  },

  // 객실 선택 (비밀번호 변경 대상 추가)
  selectRooms: async (roomIds: string[], date: string) => {
    const response = await api.post('/passwords/select', { roomIds, date });
    return response.data.data;
  },

  // 비밀번호 예약
  reservePassword: async (id: number, newPassword: string) => {
    const response = await api.put(`/passwords/${id}/reserve`, { newPassword });
    return response.data.data as PasswordChange;
  },

  // 비밀번호 적용
  applyPassword: async (id: number) => {
    const response = await api.put(`/passwords/${id}/apply`);
    return response.data.data as PasswordChange;
  },

  // 비밀번호 변경 취소
  cancelChange: async (id: number) => {
    const response = await api.put(`/passwords/${id}/cancel`);
    return response.data;
  },
};
